module.exports = __webpack_public_path__ + "016.fe670e63.png";